import BlogListingsPage, { getServerSideProps } from '@/pages/blog';

export { getServerSideProps };

export default BlogListingsPage;
